import { useState, useCallback } from 'react';
import { generateImage, fetchPreloadedImage } from '../services/imageService';

const useImageGeneration = () => {
  const [image, setImage] = useState(null);
  const [revisedPrompt, setRevisedPrompt] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateNewImage = useCallback(async (prompt, category) => {
    try {
      console.log('Starting image generation');
      setLoading(true);
      setError(null);
      
      // Only try to get a preloaded image if it's not a custom word
      if (category !== 'custom') {
        try {
          console.log('Attempting to fetch preloaded image...');
          const preloadedImagePath = await fetchPreloadedImage(prompt, category);
          if (preloadedImagePath) {
            console.log('Received preloaded image path');
            setImage(preloadedImagePath);
            setRevisedPrompt(prompt);
            return;
          }
          throw new Error(`Missing preloaded image for ${category}/${prompt}`);
        } catch (preloadError) {
          console.error('Missing preloaded category image:', preloadError);
          throw new Error('This category image is not ready yet. Please run the preload step before playing.');
        }
      } else {
        console.log('Custom word detected, skipping preloaded image check');
      }
      
      // Generate a new image
      console.log('Generating new image via OpenAI...');
      const result = await generateImage(prompt);
      console.log('Received generated image');
      setImage(result.imageUrl);
      setRevisedPrompt(result.revisedPrompt);
    } catch (err) {
      console.error('Final error in image generation:', err);
      setError(err.message || 'App at capacity. Please try again momentarily');
    } finally {
      setLoading(false);
    }
  }, []);

  const resetImage = useCallback(() => {
    console.log('Resetting image state');
    setImage(null);
    setRevisedPrompt('');
    setError(null);
  }, []);

  return {
    image,
    revisedPrompt,
    loading,
    error,
    generateNewImage,
    resetImage
  };
};

export default useImageGeneration;
